import { PrevAxios } from '../prev-front-mf-api'
import { getToken } from '../adapter/utils'
import { API_AUTH, API_HOST } from '../constants'

const isValid = (data) => {
  const receivedTimestamp = data.exp
  const currentTimestamp = Math.floor(Date.now() / 1000)
  const valid = receivedTimestamp > currentTimestamp
  return valid
}

export const JwtCheck = async () => {
  const redirectToLogin = () => {
    localStorage.removeItem('access_token_prev')
    localStorage.removeItem('refresh_token_prev')
    if (window.location.pathname === '/login-escritorio') return
    const currentSearchParams = new URLSearchParams(window.location.search)
    const loginUrl = new URL('/login-escritorio', window.location.origin)
    loginUrl.search = currentSearchParams.toString()
    window.location.href = loginUrl.toString()
  }

  const validateToken = (token: string | null) => {
    if (!token) return false
    const tokenData = getProfile(token)
    return tokenData && isValid(tokenData)
  }

  try {
    const localToken = getToken()

    if (!localToken) {
      redirectToLogin()
      return
    }

    if (validateToken(localToken)) {
      return true
    }

    const refreshToken = getToken('refresh_token_prev')
    if (!refreshToken || !validateToken(refreshToken)) {
      redirectToLogin()
      return
    }

    const response = await getRefreshToken()
    if (!response.data?.access_token || !response.data?.refresh_token) {
      redirectToLogin()
      return
    }

    localStorage.setItem('access_token_prev', response.data.access_token)
    localStorage.setItem('refresh_token_prev', response.data.refresh_token)
    return true
  } catch (err) {
    redirectToLogin()
  }
}

export async function getRefreshToken() {
  const urlToken = API_HOST + '/v1/oauth/token'
  const authApp = `Basic ${API_AUTH}`
  const refreshTokenPrev = getToken('refresh_token_prev')

  if (!refreshTokenPrev) {
    throw new Error('Refresh token não encontrado')
  }

  var payload = {
    grant_type: 'refresh_token',
    refresh_token: refreshTokenPrev,
  }

  const newTokens = await PrevAxios.post(urlToken, new URLSearchParams(payload), {
    headers: {
      Authorization: authApp,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })

  return newTokens
}

export const getProfile = (localToken): any => {
  try {
    if (localToken) {
      const base64Url = localToken.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join(''),
      )

      const data = JSON.parse(jsonPayload)
      return data
    }
  } catch (error) {
    localStorage.removeItem('access_token_prev')
    location.href = '/login-escritorio'
  }
}
